<p-dialog class="template-copy-dialog" position="top" [(visible)]="visible" [modal]="true" [style]="{ width: '750px'}" [modal]="true" [resizable]="false" [draggable]="false">
    <ng-template pTemplate="header">
        <div>
            <span class="p-mr-2 title">Copying {{template?.name || 'template'}} from {{currentLog?.name || 'current log'}}</span>
            <span class="pi pi-question-circle clickable" (click)="showHelpDialog()"></span>
        </div>
    </ng-template>

    <ng-container *ngTemplateOutlet="body"></ng-container>

    <ng-template pTemplate="footer">
        <p-divider></p-divider>
        <div class="p-text-center">
            <div *ngIf="hasErrors" class="p-mb-1">
                <p-messages class="clickable" severity="error" (click)="$event.preventDefault();showHelpDialog(4)">
                    <ng-template pTemplate>
                        <div class="p-d-flex p-ai-center">
                            <span>Verify that all required fields have been completed</span>
                            <span class="pi pi-question-circle p-ml-2"></span>
                        </div>
                    </ng-template>
                </p-messages>
            </div>
            <button pButton *ngIf="!newTemplateId" [loading]="saving" loadingIcon="p-ml-1 pi pi-spinner pi-spin" [disabled]="loadingSegments || loadingOverrides || !selectedLogId || !template" (click)="proceed()">Copy</button>
            <button pButton *ngIf="newTemplateId" class="p-button-success" label="View Copied Template" (click)="openNewTemplate()"></button>
        </div>
    </ng-template>
</p-dialog>

<ng-template #body>
    <label class="p-d-block p-mb-2">
        Copy to log <span class="pi pi-question-circle clickable" (click)="$event.preventDefault();showHelpDialog(1)"></span>
        <log-selector placeholder="Required" [memberAsRole]="LOG_ROLES.ADMIN" [(ngModel)]="selectedLog"></log-selector>
    </label>
    <ng-container *ngIf="loadingSegments || loadingOverrides; else templateEditor">
        <label class="p-d-flex p-jc-center p-ai-center">
            <span class="pi pi-spin pi-spinner"></span>
            <span class="p-ml-2">Loading Template</span>
        </label>
    </ng-container>
</ng-template>

<ng-template #templateEditor>
    <p-divider></p-divider>
    <ng-container [ngTemplateOutlet]="(!selectedLogId || noSegmentsNeedingOverride || sameLog) ? templateMessage : templateDisplay"
                  [ngTemplateOutletContext]="{ $implicit: (!selectedLogId ? 'Select a Log to continue' : (noSegmentsNeedingOverride || sameLog) ? 'No overrides are required' : '')}">
    </ng-container>

    <ng-template #templateMessage let-message>
        <div class="p-d-flex p-ai-center p-jc-center">
            <label>{{message}}</label>
        </div>
    </ng-template>
    <ng-template #templateDisplay>
        <div>
            <ng-container *ngTemplateOutlet="templateSimple"></ng-container>
        </div>
    </ng-template>
</ng-template>

<ng-template #templateSimple>
    <ng-container *ngFor="let override of simpleOverrides">
        <p-card class="segment-card" styleClass="p-mb-1">
            <label class="p-d-block" [ngSwitch]="override.type">
                {{override.name}}
                <span class="pi pi-question-circle p-ml-1 clickable" (click)="$event.preventDefault(); showHelpDialog(override.type === SEGMENT_ID.TEXT_CHOICE ? 2 : 3)"></span>
                <ng-container *ngSwitchCase="SEGMENT_ID.TAG">
                    <tag-selector emptyListMessage="No Tags in selected Log" placeholder="Required Tag" [maxItems]="1" [logId]="selectedLogId!" [(ngModel)]="override.tagValue" (ngModelChange)="setToOthers(override, override)"></tag-selector>
                </ng-container>

                <ng-container *ngSwitchCase="SEGMENT_ID.TAG_CHOICE">
                    <tag-selector emptyListMessage="No Tags in selected Log" placeholder="Optional Tag"  [maxItems]="1" [logId]="selectedLogId!" [(ngModel)]="override.tagValue" (ngModelChange)="setToOthers(override, override)"></tag-selector>
                </ng-container>

                <ng-container *ngSwitchCase="SEGMENT_ID.TEXT_CHOICE">
                    <div class="p-grid">
                        <div class="p-col-{{override.choiceListCopyStatus == 'hide' ? '12' : '9'}} p-d-flex p-flex-column p-jc-center">
                            <choicelist-selector [disabled]="override.choiceListCopyEnabled" emptyListMessage="No Lists in selected Log" [placeholder]="override.choiceListCopyEnabled ? (override.name + ' will be copied') : 'Required List'" [logId]="selectedLogId!" [(ngModel)]="override.choiceListCopyEnabled ? [] : override.choiceList" (ngModelChange)="override.defaultChoice = null; setToOthers(override, override)"></choicelist-selector>
                        </div>
                        <div *ngIf="override.choiceListCopyStatus != 'hide'" class="p-col-3">
                            <label [title]="override.choiceListCopyStatus == 'disabled' ? 'Cannot copy ' + override.name + '. A list with the same name exists in the selected log but does not contain the same items.' : ''" class="p-d-flex p-flex-column p-ai-center p-jc-center" (click)="override.choiceListCopyStatus === 'disabled' && disabledMessage.show($event)">
                                <span class="p-text-center">Copy {{override.name}}</span>
                                <div>
                                    <p-inputSwitch [disabled]="override.choiceListCopyStatus == 'disabled'" [(ngModel)]="override.choiceListCopyEnabled" (ngModelChange)="setToOthers(override, override)"></p-inputSwitch>
                                </div>
                            </label>
                            <p-overlayPanel #disabledMessage appendTo="body" [showCloseIcon]="true">
                                <span>Cannot copy {{override.name}}. A list with the same name exists in the selected log but does not contain the same items.</span>
                            </p-overlayPanel>
                        </div>
                    </div>

                    <ng-container *ngIf="override.choiceList != 'COPY' && valueFromArray(override.choiceList)">
                        <label class="default-choice-entry p-d-block">
                            Default choice
                            <choicelist-item-selector emptyListMessage="Selected list has no items" placeholder="Optional List Value" [listId]="$any(valueFromArray($any(override.choiceList))?.id)" [(ngModel)]="override.defaultChoice" (ngModelChange)="setToOthers(override, override)"></choicelist-item-selector>
                        </label>
                    </ng-container>
                </ng-container>
            </label>
        </p-card>
    </ng-container>
</ng-template>


<p-confirmDialog appendTo="body"></p-confirmDialog>

<ng-template pTemplate="helpDialogIntro">
    <p>
        Templates can be copied by Log Administrators into either a new
        duplicate template in the same Log or a new template in a different Log.
    </p>
    <p>
        To copy a template into a different Log, you must be a Log Admin for the
        destination Log The Template Copier will step you through the process.
    </p>
    <p>
        First, confirm that the template you are Copying is the correct template
        to be copied.
    </p>
</ng-template>

<ng-template pTemplate="helpDialogLogSelect">
    <p>
        Select destination Copy to Log from the available Logs. Only Logs
        for which you have Log Admin permission will be available.
    </p>
    <p>
       The name of the new template created by the copy will be suffixed as a copy.
    </p>
</ng-template>

<ng-template pTemplate="helpDialogListSelect">
    <p>
        Template Segments that reference Lists must be mapped to applicable
        Lists in the Target Log.
    </p>
    <p>
        If a referenced List does not exist in the Target Log, the List from the
        Source Log can be copied into the Target Log by choosing the respective
        Copy option. When a Source List is copied to the Target Log, all
        references to the Source List will be automatically mapped to the List
        copied to the Target Log.
    </p>
    <p>
        If a referenced List exists in the Target Log but its list items are not
        identical to the Source List, Copy will be disabled.
    </p>
    <p>
        If a referenced List exists in the Target Log and its items are identical to
        the Source List, references will automatically be mapped to the equivalent
        Target List.
    </p>
    <p>
        It is possible to map Source List references to a different Target Log List,
        when other Lists exist in the Target Log.
    </p>
</ng-template>

<ng-template pTemplate="helpDialogTagSelect">
    <p>
        Template Segments that reference Tags must be mapped to applicable
        Tags in the destination Log.
    </p>
    <p>
        Select the respective Target Log Tags to map these segment references.
    </p>
    <p>
        Note that automatically copying Tags is not available. The necessary Tags
        in the Target Log should be created manually before copying an
        applicable template to the Target Log.
    </p>
</ng-template>

<ng-template pTemplate="helpDialogIncomplete">
    <p>
        If you see this message when attempting to copy your template then it means you have required fields still remaining.
    </p>
    <p>
        Lists and tags of "Tag" type segments are required but default list items and tags of "Tag Choice" type segments are not required.
    </p>
    <p>
        Once you have completed the form {{AppStateService.screenAction}} the 'Copy' button again to continue.
    </p>
</ng-template>

